var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecimalField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2262_7644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 14C19.5832 19.2933 15.2931 23.5834 9.99984 23.5834C4.70654 23.5834 0.416504 19.2933 0.416504 14C0.416504 8.70673 4.70654 4.41669 9.99984 4.41669C15.2931 4.41669 19.5832 8.70673 19.5832 14ZM9.99984 6.21356V21.7865C14.3011 21.7865 17.7863 18.3013 17.7863 14C17.7863 9.69875 14.3011 6.21356 9.99984 6.21356Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2262_7644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1667,
    height: 19.1667,
    fill: "white",
    transform: "translate(0.416504 4.41669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecimalField);
export default __webpack_public_path__ + "static/media/decimal-field.4a654c7d3dc3aaf28b66adb5eea707d0.svg";
export { ForwardRef as ReactComponent };